import { createSlice } from '@reduxjs/toolkit';
import { createFormalQuote } from 'formal_quote/thunks';

const initialState = {
  showForm: false,
  formData: {
    recipient_name: '',
    company_name: '',
    job_title: '',
    email: '',
    phone_number: '',
    software_type: '',
    looking_for: 'new_license',
    portability_option: '',
    delivery_method: 'instant_download',
    license_type: '',
    license_scope: null,
    number_of_users: '1',
    billing_address: '',
    billing_city: '',
    billing_country: '',
    billing_state: '',
    billing_country_region: '',
    billing_zip_code: '',
    delivery_address: '',
    delivery_city: '',
    delivery_country: '',
    delivery_state: '',
    delivery_country_region: '',
    delivery_zip_code: '',
    same_as_billing: true,
  },
  errors: {},
  loading: false,
  error: null,
  successModal: false,
};

const inlineFormalQuoteSlice = createSlice({
  name: 'inlineFormalQuote',
  initialState,
  reducers: {
    showFormalQuoteForm: (state) => {
      state.showForm = true;
    },
    hideFormalQuoteForm: (state) => {
      state.showForm = false;
    },
    setFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    showSuccessModal: (state) => {
      state.successModal = true;
    },
    dismissSuccessModal: (state) => {
      state.successModal = false;
    },
    resetForm: (state) => {
      state.errors = {};
      state.loading = false;
      state.error = null;
      state.formData = {
        ...initialState.formData,
        software_type: state.formData.software_type,
        number_of_users: state.formData.number_of_users,
        delivery_method: state.formData.delivery_method,
        portability_option: state.formData.portability_option,
        license_type: state.formData.license_type,
        license_scope: state.formData.license_scope,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFormalQuote.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFormalQuote.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createFormalQuote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
      });
  },
});

export const {
  showFormalQuoteForm,
  hideFormalQuoteForm,
  setFormData,
  setErrors,
  clearErrors,
  showSuccessModal,
  dismissSuccessModal,
  resetForm,
} = inlineFormalQuoteSlice.actions;

export default inlineFormalQuoteSlice.reducer;
